import {FC, ReactNode} from 'react';

type InboxTableLayoutProps = {
    children: ReactNode;
};

const InboxTableLayout: FC<InboxTableLayoutProps> = ({children}) => (
    <div className="my-4 max-w-5xl rounded-md border border-grey-300 bg-white p-4 shadow-lg 2xl:max-w-[94rem]">
        {children}
    </div>
);

export default InboxTableLayout;
